import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const PaymentsOverview = ({ className, dashboardData }) => {
  const [timeFrame, setTimeFrame] = useState('monthly');

  // Use real market trends data or fallback to mock
  const marketTrends = dashboardData?.marketTrends || [
    { month: 'Jan', avgPrice: 250000, count: 45 },
    { month: 'Feb', avgPrice: 265000, count: 50 },
    { month: 'Mar', avgPrice: 275000, count: 60 },
    { month: 'Apr', avgPrice: 280000, count: 65 },
    { month: 'May', avgPrice: 285000, count: 70 },
    { month: 'Jun', avgPrice: 290000, count: 75 },
    { month: 'Jul', avgPrice: 295000, count: 80 },
    { month: 'Aug', avgPrice: 300000, count: 85 },
    { month: 'Sep', avgPrice: 305000, count: 88 },
    { month: 'Oct', avgPrice: 310000, count: 90 },
    { month: 'Nov', avgPrice: 308000, count: 85 },
    { month: 'Dec', avgPrice: 315000, count: 92 },
  ];

  const receivedData = marketTrends.map(d => ({ x: d.month, y: d.count }));
  const dueData = marketTrends.map(d => ({ x: d.month, y: Math.round((d.avgPrice / 10000)) }));

  const receivedTotal = receivedData.reduce((acc, { y }) => acc + y, 0) * 10;
  const dueTotal = dueData.reduce((acc, { y }) => acc + y, 0) * 10;

  const options = {
    colors: ['#5750F1', '#0ABEF9'],
    chart: {
      type: 'area',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    fill: {
      type: 'gradient',
      gradient: {
        opacityFrom: 0.55,
        opacityTo: 0,
      },
    },
    grid: {
      strokeDashArray: 5,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      categories: receivedData.map(d => d.x),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    legend: {
      show: false,
    },
  };

  const series = [
    {
      name: 'Received Amount',
      data: receivedData.map(d => d.y),
    },
    {
      name: 'Due Amount',
      data: dueData.map(d => d.y),
    },
  ];

  return (
    <div
      className={`grid gap-2 rounded-10 bg-white px-7.5 pb-6 pt-7.5 shadow-1 dark:bg-gray-dark dark:shadow-card ${className || ''}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h2 className="text-body-2xlg font-bold text-dark dark:text-white">
          Payments Overview
        </h2>

        <select
          value={timeFrame}
          onChange={(e) => setTimeFrame(e.target.value)}
          className="rounded border border-stroke px-3 py-1 text-sm font-medium dark:border-dark-3 dark:bg-dark-2"
        >
          <option value="monthly">Monthly</option>
          <option value="weekly">Weekly</option>
          <option value="daily">Daily</option>
        </select>
      </div>

      <div className="-ml-3.5">
        <ReactApexChart
          options={options}
          series={series}
          type="area"
          height={350}
        />
      </div>

      <dl className="grid divide-stroke text-center dark:divide-dark-3 sm:grid-cols-2 sm:divide-x">
        <div className="dark:border-dark-3 max-sm:mb-3 max-sm:border-b max-sm:pb-3">
          <dt className="text-xl font-bold text-dark dark:text-white">
            {receivedTotal.toLocaleString()}
          </dt>
          <dd className="font-medium dark:text-dark-6">Total Properties Listed</dd>
        </div>

        <div>
          <dt className="text-xl font-bold text-dark dark:text-white">
            ${(dueTotal * 10000).toLocaleString()}
          </dt>
          <dd className="font-medium dark:text-dark-6">Avg Market Value</dd>
        </div>
      </dl>
    </div>
  );
};

export default PaymentsOverview;
